import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { addQueryToUrl } from 'dpl/util/queryString';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURE_LOCATIONS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import ClickableDiv from 'dpl/common/components/ClickableDiv';
import Icon from 'dpl/common/components/Icon';

// components used for landing/SEO improvements on breeder profile page
export function SearchPuppiesNearYouCard({ breed }) {
  const { searchLocationTitle, searchUserCoordinates } = useSelector(
    ({ server }) => server
  );

  const cardLabel = `Search ${breed.pluralized_name} near you`;

  function handleClick() {
    sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_cta: 'Search breed near you',
      view: ANALYTICS_VIEWS.BREEDER_PROFILE,
      view_feature: ANALYTICS_VIEW_FEATURES.SEARCH_BREED_NEAR_YOU_CARD,
      view_feature_location:
        ANALYTICS_VIEW_FEATURE_LOCATIONS.PUPPY_CAROUSEL_SEARCH_CARD
    });

    const searchUrl = addQueryToUrl(
      {
        lat: searchUserCoordinates[0],
        long: searchUserCoordinates[1],
        locName: searchLocationTitle,
        origin_view: ANALYTICS_VIEWS.BREEDER_PROFILE,
        origin_view_feature_location:
          ANALYTICS_VIEW_FEATURE_LOCATIONS.PUPPY_CAROUSEL_SEARCH_CARD
      },
      `/${breed.slug}/results`
    );

    window.location.assign(searchUrl);
  }

  return (
    <>
      <ClickableDiv
        className="h-100"
        onClick={handleClick}
        style={{ minHeight: '360px' }}
      >
        <div className="SearchPuppiesNearYouCard flex flex-column gap-24 justify-center items-center h-100 bg-white ba b--default br3 ph4 pv4">
          <div className="br-100 bg-gray-200 ph3 pv3">
            <Icon name="fetch-search" />
          </div>
          <p className="font-16 fw-medium stone-700">{cardLabel}</p>
        </div>
      </ClickableDiv>
    </>
  );
}

SearchPuppiesNearYouCard.propTypes = {
  breed: PropTypes.shape({
    pluralized_name: PropTypes.string,
    slug: PropTypes.string
  }).isRequired
};
